// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error-container[data-v-28a1a712]{color:#333}.error-code[data-v-28a1a712]{font-size:80px;font-weight:300}", ""]);
// Exports
module.exports = exports;
